var currentScale = 0;

applySavedScale();

function applySavedScale() {
    const savedScale = window.localStorage.getItem('char-zoom-scale');
    if(savedScale === null || savedScale == 0) {
        return;
    }
    if(savedScale > 0) {
        for (let i = 0; i < savedScale; i++) {
            resizeFont(document.getElementsByClassName('resizable-font'), true);
        }
        return;
    }
    for (let i = savedScale; i < 0; i++) {
        resizeFont(document.getElementsByClassName('resizable-font'), false);
    }
}

function getFontSize(domElement) {
    return parseFloat(window.getComputedStyle(domElement, null).getPropertyValue('font-size'));
}

function getWidthSize(domElement) {
    return parseFloat(window.getComputedStyle(domElement, null).getPropertyValue('width'));
}

function getHeightSize(domElement) {
    return parseFloat(window.getComputedStyle(domElement, null).getPropertyValue('height'));
}

function resizeFont(domElements, aumentar)
{
    if(aumentar) {
        if(currentScale > 10) {
            return;
        }
        currentScale++;
    } else {
        if(currentScale <= -3) {
            return;
        }
        currentScale--;
    }
    for (let i = 0; i < domElements.length; i++) {
        const element = domElements[i];
        if(element.tagName == 'IMG') {
            const newWidth = aumentar ? getWidthSize(element) + 1 : getWidthSize(element) - 1;
            const newHeight = aumentar ? getHeightSize(element) + 1 : getHeightSize(element) - 1;
            element.style.width = newWidth.toString() + 'px';
            element.style.height = newHeight.toString() + 'px';
            continue;
        }

        const newFontSize = aumentar ? getFontSize(element) + 1 : getFontSize(element) - 1;
        element.style.fontSize = newFontSize.toString() + 'px';
    }

    window.localStorage.setItem('char-zoom-scale', currentScale);
}



window.fontResizeDown = function() {
    const elements = document.getElementsByClassName('resizable-font');
    resizeFont(elements, false);
};

window.fontResizeUp = function() {
    const elements = document.getElementsByClassName('resizable-font');
    resizeFont(elements, true);
};

window.fontResizeToNormal = function() {
    const elements = document.getElementsByClassName('resizable-font');
    while(currentScale > 0) {
        resizeFont(elements, false);
    }
    while(currentScale < 0) {
        resizeFont(elements, true);
    }
};
